export function mergeArrays<T>(
  a1: T[],
  a2: T[],
  comparator: (item1: T, item2: T) => boolean = (item1, item2) =>
    item1 === item2
): T[] {
  const resA = a1.slice();
  for (const oldItem of a2) {
    if (
      resA.findIndex((existingItem) => comparator(existingItem, oldItem)) === -1
    ) {
      resA.push(oldItem);
    }
  }
  return resA;
}

export function arrayMoveElementFromTo<T>(
  array: T[],
  from: number,
  to: number
) {
  const elementToMove = array.slice(from, 1)[0];
  const remainingElements = array.slice(1, array.length);
  remainingElements.splice(to, 0, elementToMove);
  return remainingElements;
}
